$ const {
  loadMoreButton,
  filterBar,
  title,
  headerLink
} = input;
<div class=['evo-masonry', input.class]>
  <if(title?.renderBody)>
    <header class='evo-masonry__header'>
      <h3 class=['evo-masonry__title', title.class]>
        <${title.renderBody}/>
      </h3>
      <if(headerLink?.renderBody)>
        <${headerLink.href ? 'a' : 'button'} ...headerLink target=(headerLink.href ? '_blank' : undefined) on-click('onHeaderLinkClick') class=['evo-masonry__btn-text', headerLink.class]>
          <${headerLink.renderBody}/>
        </>
      </if>
    </header>
  </if>
  <if(filterBar?.renderBody)>
    <div class=['evo-masonry__filter-bar', filterBar.class]>
      <${filterBar.renderBody}/>
    </div>
  </if>
  <div class='evo-masonry__hidden-element'>
    <div key='grid-style-proxy' class='evo-masonry-grid'/>
  </div>
  <div key='grid' class='evo-masonry-grid' style=['row-gap: 0px', 'grid-auto-rows: 1px'] data-images-loading=`${state.imagesLoading}` data-animate-first-load=input.animateFirstLoad>
    <for|item| of=state.items>
      $ const [width, height] = item.aspectRatio.split('/');
      <div key=item.id class='evo-masonry-grid__item' data-masonry-item=item.id data-masonry-group=item.groupIndex data-loaded=`${item.loaded}` data-aspect-ratio=`${item.aspectRatio}` style=[`--aspect-ratio: ${item.aspectRatio}`, `--width: ${width}`,
      // fallback for older browsers
      `--height: ${height}`,
      // fallback for older browsers
      `--stagger: ${item.groupItemIndex}`, input.focusIndicatorLabel && `--focus-indicator-label: "${input.focusIndicatorLabel}"`]>
        <${item.node.renderBody}/>
      </div>
    </for>
  </div>
  <if(loadMoreButton)>
    <div class=['evo-masonry__footer', loadMoreButton.class]>
      <ebay-button priority='tertiary' size='large' on-click('onLoadMore') disabled=state.loading bodyState=(state.loading ? 'loading' : 'none') fluid style='max-width: 240px;'>
        <${loadMoreButton.renderBody}/>
      </ebay-button>
    </div>
  </if>
</div>